import React from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

export default function EmployeeAssetsInformation({
  assignedAssetInformation,
}: any) {
  return (
    <div>
      <div className="modal fade" id="asset_info">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Asset Information</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="bg-light p-3 rounded d-flex align-items-center mb-3">
                <span className="avatar avatar-lg flex-shrink-0 me-2">
                  <ImageWithBasePath
                    src="assets/img/laptop.jpg"
                    alt="img"
                    className="ig-fluid rounded-circle"
                  />
                </span>
                <div>
                  <h6>{assignedAssetInformation?.product_name || "N/A"}</h6>
                  <p className="fs-13">
                    <span className="text-primary">AST - 001 </span>
                    <i className="ti ti-point-filled text-primary" /> Assigned date:  
                    {assignedAssetInformation?.assigned_date?.slice(0, 10) || "N/A"} 
                  </p>
                </div>
              </div>

              <div className="row">
                {assignedAssetInformation?.assigned_by_name && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Assigned By</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.assigned_by_name}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.company_name && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Company</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.company_name}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.product_brand && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Brand</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.product_brand}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.product_model && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Model</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.product_model}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.serial_no && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Serial No</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.serial_no}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.product_purchase_from && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Purchased From</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.product_purchase_from}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.product_warranty && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Warranty</p>
                      <p className="text-gray-9">
                        {assignedAssetInformation.product_warranty.slice(0, 10)}
                      </p>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.is_lost && (
                  <div className="col-md-6">
                    <div className="mb-3">
                      <p className="fs-13 mb-0">Status</p>
                      <span className="badge badge-warning d-inline-flex align-items-center">
                        <i className="ti ti-alert-triangle me-1" />
                        Lost
                      </span>
                    </div>
                  </div>
                )}

                {assignedAssetInformation?.is_lost &&
                  assignedAssetInformation?.lost_date && (
                    <div className="col-md-6">
                      <div className="mb-3">
                        <p className="fs-13 mb-0">Lost Date</p>
                        <p className="text-gray-9">
                          {assignedAssetInformation.lost_date.slice(0, 10)}
                        </p>
                      </div>
                    </div>
                  )}

                {assignedAssetInformation?.is_lost &&
                  assignedAssetInformation?.lost_remark && (
                    <div className="col-md-12">
                      <div className="mb-3">
                        <p className="fs-13 mb-0">Lost Remark</p>
                        <p className="text-gray-9">
                          {assignedAssetInformation.lost_remark}
                        </p>
                      </div>
                    </div>
                  )}

                {!assignedAssetInformation?.is_lost &&
                  assignedAssetInformation?.unassigned_date && (
                    <div className="col-md-6">
                      <div className="mb-3">
                        <p className="fs-13 mb-0">Unassigned Date</p>
                        <p className="text-gray-9">
                          {assignedAssetInformation.unassigned_date.slice(0, 10)}
                        </p>
                      </div>
                    </div>
                  )}
              </div>

              <div>
                <p className="fs-13 mb-2">Asset Images</p>
                <div className="d-flex align-items-center">
                  <ImageWithBasePath
                    src="assets/img/laptop-01.jpg"
                    alt="img"
                    className="img-fluid rounded me-2"
                  />
                  <ImageWithBasePath
                    src="assets/img/laptop-2.jpg"
                    alt="img"
                    className="img-fluid rounded me-2"
                  />
                  <ImageWithBasePath
                    src="assets/img/laptop-3.jpg"
                    alt="img"
                    className="img-fluid rounded"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}